import { useT } from '@transifex/react'
import React from 'react'

export const LineItemFulfilmentCustomerHeaderView: React.FC = () => {
  const t = useT()

  return (
    <div className="uc-base font-general">
      <div className="flex flex-col gap-2">
        <h3 className="typography-heading-sm text-fg-neutral-default">
          {t('Add a customer to the sale', {
            _context: 'Line item fulfilment popover',
          })}
        </h3>
        <p className="typography-body-sm text-fg-neutral-soft">
          {t(
            'Contact information will be used to reach out to the customer about the sale.',
            { _context: 'Line item fulfilment popover' }
          )}
        </p>
      </div>
    </div>
  )
}
